// The sidebar's Hilos entry: the SERVER's totals for the team (shared/API.md §13.1 — never a sum of
// the cached page), kept in sync_state by the worker's refreshThreads and brought down on the tap
// by markThreadRead / markAllThreadsRead. `enabled` is ThreadsAvailability: hide the entry when it
// is false, rather than open a screen that can only ever say "no threads".
import { data } from '../../../bridge/client';
import { useLive } from '../../hooks';
import { ThreadsDerivation } from '../../../core/threadsDerivation';
import { threadsEnabled } from './destinationsModel';

export interface ThreadsBadge {
  unreadThreads: number;
  unreadMentions: number;
  /** What the entry's badge SAYS (ThreadsDerivation.entryBadge): threads waiting, else mentions; null = none. */
  label: string | null;
  enabled: boolean;
}

const NONE: ThreadsBadge = { unreadThreads: 0, unreadMentions: 0, label: null, enabled: false };

export function useThreadsBadge(teamId: string | null | undefined): ThreadsBadge {
  const { value } = useLive(
    async () => {
      if (!teamId) return NONE;
      const s = await data.call('threadsBadge', teamId);
      const entry = ThreadsDerivation.entry(s.unreadThreads, s.unreadMentions);
      return { ...entry, label: ThreadsDerivation.entryBadge(entry), enabled: threadsEnabled(s) };
    },
    ['syncState'],
    [teamId ?? ''],
  );
  return value ?? NONE;
}
